import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { clamp, loadJSON, saveJSON } from "../utils/desktop";

const STORAGE_KEY = "volume";
const DEFAULT_VOLUME = { level: 1, muted: false };

const loadVolume = () => {
  const v = loadJSON(STORAGE_KEY);
  const valid = v && Number.isFinite(v.level) && typeof v.muted === "boolean";
  return valid ? { level: clamp(v.level, 0, 1), muted: v.muted } : DEFAULT_VOLUME;
};

const VolumeContext = createContext(null);

export const VolumeProvider = ({ children }) => {
  const [volume, setVolume] = useState(loadVolume);

  useEffect(() => {
    saveJSON(STORAGE_KEY, volume);
  }, [volume]);

  const value = useMemo(
    () => ({
      ...volume,
      // The level sound sources should actually play at.
      effective: volume.muted ? 0 : volume.level,
      setLevel: (level) => setVolume((v) => ({ ...v, level: clamp(level, 0, 1) })),
      setMuted: (muted) => setVolume((v) => ({ ...v, muted })),
    }),
    [volume]
  );

  return <VolumeContext.Provider value={value}>{children}</VolumeContext.Provider>;
};

export const useVolume = () => {
  const ctx = useContext(VolumeContext);
  if (!ctx) {
    throw new Error("useVolume must be used inside VolumeProvider");
  }
  return ctx;
};
